document.addEventListener('DOMContentLoaded', function () {

    const MOBILE_WIDTH = 968;
    let isMobile = window.innerWidth <= MOBILE_WIDTH;

    function handleAccordion(isInitial = false) {
        const nowMobile = window.innerWidth <= MOBILE_WIDTH;
        const stages = document.querySelectorAll('.teaser-list-stage');
        const headers = document.querySelectorAll('.teaser-accordion-header');

        if ((isInitial && nowMobile) || (!isMobile && nowMobile)) {
            if (stages.length) {
                stages.forEach(stage => stage.classList.remove('active'));
                stages[0].classList.add('active');
            }
        }

        if (isMobile && !nowMobile) {
            stages.forEach(stage => stage.classList.remove('active'));
        }

        headers.forEach(header => {
            if (header.dataset.bound) return;
            header.dataset.bound = 'true';

            header.addEventListener('click', function () {
                const stage = this.closest('.teaser-list-stage');
                const isActive = stage.classList.contains('active');

                stages.forEach(s => s.classList.remove('active'));

                if (!isActive) {
                    stage.classList.add('active');
                }
            });
        });

        isMobile = nowMobile;
    }

    handleAccordion(true);
    window.addEventListener('resize', () => handleAccordion(false));
});